// Body for the App Packs editor's POST /proxy/apps/:slug. The pack is spread whole so every
// key sanitizePack whitelists (notably identity.metaAppIds, which a save that omitted it would
// drop) round-trips; metaPlacementReport is server-owned (the import route writes it) and is
// never sent.
export function buildPackSavePayload(pack, field, rules) {
  const { metaPlacementReport: _serverOwned, ...rest } = pack && typeof pack === 'object' ? pack : {};
  return { ...rest, [field]: rules };
}
